<template>
  <header>
    <div class="logo">
      <h1 href="/"><img src="../../../public/static/mp_logo_w_min.png" alt="MailPublisherHTMLeditor" width="220" height="58"></h1>
    </div>
    <div class="flex">
      <!-- メッセージ表示 -->
      <div class="toast-box">
        <transition name="fade">
          <div
            v-if="showMessageToast"
            :class="{'toast-success': toastSuccessClass, 'toast-error': toastErrorClass}"
          >
            <span>{{ $store.state.status.messageToasts[0].message }}</span>
          </div>
        </transition>
      </div>
      <ul class="header-nav">
        <li @click="[isShowLinkCheckerModal = true, openLinkChecker()]">リンクチェッカー</li>
        <li @click="isShowHTMLPreviewModal = true">プレビュー</li>
        <li
          @click="testSendOption = !testSendOption"
          v-on-clickaway="testSendHidden"
        >
            テスト送信
          <transition name="fade">
            <ul v-show="testSendOption">
              <li @click="isShowSendTestMailModal = true">メール</li>
              <li @click="shareUrl">URL</li>
            </ul>
          </transition>
        </li>
        <li
          @click="exportOption = !exportOption"
          v-on-clickaway="exportHidden"
        >
          エクスポート
          <transition>
            <ul v-show="exportOption">
              <li v-if="isExtTypeNameEcV1" @click="!hasEmptyImage() && showExportEcV1Modal()">EngageCros連携</li>
              <li v-else-if="isExtTypeNameEcV2" @click="!hasEmptyImage() && showExportEcV2Modal()">EngageCros連携</li>
              <li v-else-if="isExtTypeNameMpLite" @click="!hasEmptyImage() && showExportMpLiteModal()">MailPublisher Lite連携</li>
              <li v-else-if="isExtTypeNameMpNext" @click="!hasEmptyImage() && showExportMpNextModal()">MailPublisher Next連携</li>
              <li v-else @click="!hasEmptyImage() && showExportMpModal()">MailPublisher連携</li>
              <li @click="!hasEmptyImage() && showExportLocalModal()">ZIPダウンロード</li>
              <li @click="!hasEmptyImage() && showPublishWebModal()">WEB公開</li>
            </ul>
          </transition>
        </li>
        <li data-shortcut-ctl-s="editorHeaderSaveButton" @click="save">保存</li>
        <li
          @click="close"
          data-shortcut-esc="editorHeaderCloseButton"
        >
          閉じる
        </li>
      </ul>
      <div
        class="side-nav"
        @click="sideNavOption = !sideNavOption"
        v-on-clickaway="sideNavHidden"
      >
        <i class="fas fa-ellipsis-v"></i>
        <side-navigation
          v-show="sideNavOption"
        />
      </div>
    </div>
    <portal v-if="isShowLinkCheckerModal" to="modal1">
      <link-checker @close="isShowLinkCheckerModal = false"/>
    </portal>
    <portal v-if="isShowHTMLPreviewModal" to="modal1">
      <html-preview @close="isShowHTMLPreviewModal = false"/>
    </portal>
    <portal v-if="isShowSendTestMailModal" to="modal1">
      <send-test-mail @close="isShowSendTestMailModal = false"/>
    </portal>
    <portal v-if="isShowExportEcV1Modal" to="modal1">
      <export-ec-v1 @close="isShowExportEcV1Modal = false"/>
    </portal>
    <portal v-if="isShowExportEcV2Modal" to="modal1">
      <export-ec-v2 @close="isShowExportEcV2Modal = false"/>
    </portal>
    <portal v-if="isShowExportMpLiteModal" to="modal1">
      <export-mp-lite @close="isShowExportMpLiteModal = false"/>
    </portal>
    <portal v-if="isShowExportMpNextModal" to="modal1">
      <export-mp-next @close="isShowExportMpNextModal = false"/>
    </portal>
    <portal v-if="isShowExportMpModal" to="modal1">
      <export-mp @close="isShowExportMpModal = false"/>
    </portal>
    <portal v-if="isShowExportLocalModal" to="modal1">
      <export-local :extTypeName="extTypeName" @close="isShowExportLocalModal = false"/>
    </portal>
    <portal v-if="isShowPublishWebModal" to="modal1">
      <publish-web @close="isShowPublishWebModal = false"/>
    </portal>
  </header>
</template>

<script>
import { mixin as onClickAway } from 'vue-clickaway'
import ShortCutBase from '@/mixins/ShortCutBase'
import sideNavigation from '@/components/Util/SideNavigation'
import base from '@/components/Content/Check/ContentCheckBase'
import LinkChecker from '@/components/Content/Check/LinkChecker'
import HtmlPreview from '@/components/Content/Check/HTMLPreview'
import SendTestMail from '@/components/Content/Check/SendTestMail'
import ExportEcV1 from '@/components/Content/Check/ExportEcV1'
import ExportEcV2 from '@/components/Content/Check/ExportEcV2'
import ExportMp from '@/components/Content/Check/ExportMp'
import ExportMpLite from '@/components/Content/Check/ExportMpLite'
import ExportMpNext from '@/components/Content/Check/ExportMpNext'
import ExportLocal from '@/components/Content/Check/ExportLocal'
import PublishWeb from '@/components/Content/Check/PublishWeb'

export default {
  name: 'content-header',
  mixins: [
    base,
    onClickAway,
    ShortCutBase
  ],
  components: {
    sideNavigation,
    LinkChecker,
    HtmlPreview,
    SendTestMail,
    ExportEcV1,
    ExportEcV2,
    ExportMp,
    ExportMpLite,
    ExportMpNext,
    ExportLocal,
    PublishWeb,
  },
  data () {
    return {
      testSendOption: false,
      exportOption: false,
      sideNavOption: false,
      isShowLinkCheckerModal: false,
      isShowHTMLPreviewModal: false,
      isShowSendTestMailModal: false,
      isShowExportMpModal: false,
      isShowExportEcV1Modal: false,
      isShowExportEcV2Modal: false,
      isShowExportMpLiteModal: false,
      isShowExportMpNextModal: false,
      isShowExportLocalModal: false,
      isShowPublishWebModal: false,
      isSaving: false,
      extTypeName: '',
      mobileCSS: '',
      model: {
        type: 'layout',
        name: '',
      },
    }
  },
  created () {
    this.getExtTypeName()
  },
  computed: {
    showMessageToast () {
      return this.$store.state.status.messageToasts.length > 0
    },
    toastSuccessClass () {
      return this.$store.state.status.messageToasts[0].kind === 'success'
    },
    toastErrorClass () {
      return this.$store.state.status.messageToasts[0].kind === 'error'
    },
    isExtTypeNameEcV1 () {
      return this.extTypeName === 'ec_v1'
    },
    isExtTypeNameEcV2 () {
      return this.extTypeName === 'ec_v2'
    },
    isExtTypeNameMpLite () {
      return this.extTypeName === 'mp_lite'
    },
    isExtTypeNameMpNext () {
      return this.extTypeName === 'mp_next'
    },
  },
  mounted () {
    this.$store.commit('clearMessageToast')
  },
  methods: {
    testSendHidden () {
      this.testSendOption = false
    },
    exportHidden () {
      this.exportOption = false
    },
    sideNavHidden () {
      this.sideNavOption = false
    },
    showExportEcV1Modal () {
      this.isShowExportEcV1Modal = true
    },
    showExportEcV2Modal () {
      this.isShowExportEcV2Modal = true
    },
    showExportMpLiteModal () {
      this.isShowExportMpLiteModal = true
    },
    showExportMpNextModal () {
      this.isShowExportMpNextModal = true
    },
    showExportMpModal () {
      this.isShowExportMpModal = true
    },
    showExportLocalModal () {
      this.isShowExportLocalModal = true
    },
    showPublishWebModal () {
      this.isShowPublishWebModal = true
    },
    openLinkChecker () {
      this.$store.commit('openedLinkChecker')
    },
    getExtTypeName () {
      this.$http({
        url: `/site`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.extTypeName = json.data.extTypeName
        }
      })
    },
    async shareUrl () {
      // コードパーツ 未使用の画像を削除
      this.$store.commit('deleteCodePartUnUseImage', this.$store.getters.getSectionAll)
      // テストURL発行前に、HTMLを作成してサイズを取得し、保存リクエストを送る
      this.createRawHTML()
      await this.getContentSize()
      const saveJson = await this.$store.dispatch('savePreviewData')
      if (!saveJson || saveJson.status !== 200) return

      const sections = await this.getTestPublicSections({ type: 'share' })
      if (!sections) return

      this.createRawHTML(sections)

      const formData = new FormData()
      formData.append('body', this.rawHTML)
      // モバイルスタイルCSS
      this.mobileCSS = this.createMobileCSS()
      if (this.mobileCSS) formData.append('mobileCss', this.mobileCSS)
      // メール用CSS
      formData.append('headCss', this.createHeadCSS())
      // outlook CSS
      formData.append('outlookCss', this.createOutlookCSS())
      const json = await this.$http({
        url: '/hosting/share/' + this.$route.params.id,
        type: 'POST',
        params: formData,
      })
      if (json && json.status === 200) {
        this.$store.commit('mergeMessagePopup', {
          isShow: true,
          isSuccess: true,
          title: 'テストURLを発行しました',
          messages: [json.data.url],
        })
      }
    },
    async save () {
      if (this.isSaving) return
      this.isSaving = true
      // コードパーツ 未使用の画像を削除
      this.$store.commit('deleteCodePartUnUseImage', this.$store.getters.getSectionAll)
      this.createRawHTML(this.$store.getters.getSectionAll)
      await this.getContentSize()
      await this.$store.dispatch('savePreviewData')
      this.isSaving = false
    },
    close () {
      if (this.isSaving) return
      this.$router.push({ name: 'contentList' })
    }
  }
}
</script>
<style lang="scss" scoped>
header {
  color: rgba(#fff, 0.4);
  background: $primaryMenuColor;
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid #dbdbdb;
  .logo {
    h1 {
      font-size: 24px;
      font-weight: bold;
      padding-left: 20px;
      margin: 0;
      img {
        width: 220px;
        height: auto;
        padding: 5px 0;
      }
    }
  }
  .flex {
    display: flex;
    align-items: center;
    .toast-box {
      min-width: 100px;
      .fade-enter-active {
        transition: opacity 0.1s;
      }
    }
    .header-nav {
      display: flex;
      font-size: 12px;
      margin: 0;
      height: 70px;
      > li {
        padding: 12px;
        padding-top: ７px;
        margin: 0 3px;
        min-width: 80px;
        height: 70px;
        box-sizing: border-box;
        white-space: nowrap;
        font-weight: 300;
        border-radius: 2px;
        transition: all 0.3s ease 0s;
        text-align: center;
        position: relative;
        cursor: pointer;
        &:hover, &:active {
          color: #fff;
          background: rgba($primaryHoverColor, 0.3);
          transition: all 0.3s ease 0s;
          border-radius: 2px;
        }
        &::before {
          font-family: "Font Awesome 5 Free";
          display: block;
          text-align: center;
          font-size: 18px;
        }
        &:nth-of-type(1) {
          position: relative;
          &::before {
            content: '\f0c1';
            font-weight: 900;
          }
          &::after {
            font-family: "Font Awesome 5 Free";
            display: block;
            line-height: 0.9;
            background: $primaryMenuColor;
            content: '\f14a';
            font-size: 11px;
            position: absolute;
            top: 27px;
            right: 48px;
            transition: all 0.3s ease 0s;
          }
          &:hover::after {
            background: rgba($primaryHoverColor, 0.3);
          }
        }
        &:nth-of-type(2)::before {
          content: '\f06e';
        }
        &:nth-of-type(3){
          &::before {
            content: '\f492';
            font-weight: 900;
          }
          &::after {
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
            content: '\f107';
            padding-left: 5px;
          }
        }
        &:nth-of-type(4) {
          &::before {
            content: '\f56e';
            font-weight: 900;
          }
          &::after {
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
            content: '\f107';
            padding-left: 5px;
          }
        }
        &:nth-of-type(5)::before {
          content: '\f0c7';
          font-weight: 900;
        }
        &:nth-of-type(6)::before {
          content: '\f00d';
          font-weight: 900;
        }
        &>ul {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          padding: 15px 10px;
          background: $primaryMenuColor;
          z-index: 3;
          box-shadow: 0 3px 4px rgba(198, 198, 198, 0.5);
          text-align: left;
          &>li {
            transition: all 0.3s ease 0s;
            line-height: 2;
            padding: 0 20px;
            &:hover {
              background: rgba($primaryHoverColor, 0.3);
              border-radius: 2px;
            }
            &.disable {
              &:hover {
                background: #fff;
                border-radius: 0;
              }
              cursor: default;
              color: #888;
            }
          }
        }
      }
    }
    .side-nav {
      margin-right: 20px;
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      border-radius: 38px;
      position: relative;
      transition: all 0.3s ease 0s;
      &:hover {
        color: #fff;
        background: rgba($primaryHoverColor, 0.3);
      }
      .side-navigation {
        background: $primaryMenuColor;
        position: absolute;
        width: 220px;
        top: 100%;
        right: 0;
        padding: 15px 20px;
        z-index: 3;
        box-shadow: 0 3px 4px rgba($baseFontColor, 0.5);
        text-align: left;
      }
    }
  }
}
</style>
